<template>
    <div class="page-init" v-if="!page_init">游戏加载中...</div>
    <div v-else class="slot-bg">
        <div class="container">
            <h1>🎰 幸运拉霸 🎰</h1>
            <div class="game-info">
                <div class="info-item">
                    <div class="info-label">机箱余额</div>
                    <div class="info-value rw-con" @click="rwBtn">
                        <img class="rw-img" src="@assets/images/slot/rw.png"/>
                        <div class="points">{{ points }}</div>
                    </div>
                </div>
                <div class="info-item">
                    <div class="info-label">投注金额</div>
                    <div class="info-value">{{ currentBet }}</div>
                </div>
                <div class="info-item">
                    <div class="info-label">赢得金额</div>
                    <div class="info-value">{{ winPoints }}</div>
                </div>
            </div>
            <!--充值提现弹窗-->
            <div class="rw-popup-con" v-if="rw_pop">
                <div class="rw-popup">
                    <div class="row"><i>账户余额</i>：<b>{{balance}}</b></div>
                    <div class="row"><i>机箱余额</i>：<b>{{points}}</b></div>
                    <div class="row">
                        <input type="number" ref="amount" placeholder="请输入金额" v-model="amount"/>
                    </div>
                    <div class="rw-btn-con">
                        <button class="rw-btn in" @click="rwIn">投币</button>
                        <button class="rw-btn out" @click="rwOut">退币</button>
                    </div>
                </div>
                <div class="rw-popup-close" @click="rwClose">⊗</div>
            </div>
            <div class="game-area">
                <div class="slot-machine" :class="{'full-prize-border': hasFullPrizeBorder}">
                    <div v-for="(column, colIndex) in columns" :key="colIndex" class="slot-column">
                        <div class="slot-wheel" :style="{
                                transform: `translateY(${column.position}px)`,
                                transition: `transform ${column.duration}ms cubic-bezier(${column.easing})`
                            }">
                            <div v-for="(item, index) in column.items" :key="index" class="slot-item">
                                {{ getSymbolDisplay(item) }}
                            </div>
                        </div>
                        <div class="slot-mask">
                            <div class="mask-top"></div>
                            <div class="center-line"></div>
                            <div class="mask-bottom"></div>
                        </div>
                    </div>

                    <!-- 大奖行边框 -->
                    <div v-for="row in bigPrizeRows" :key="row" class="row-border" :class="'row-' + row"></div>

                    <!-- 连线特效 -->
                    <div v-if="showLineEffect" class="line-effect horizontal-line"></div>

                    <!-- 斜线特效 -->
                    <div v-if="showDiagonalEffect1" class="line-effect diagonal-line-1"></div>
                    <div v-if="showDiagonalEffect2" class="line-effect diagonal-line-2"></div>
                </div>
            </div>

            <div class="controls">
                <div class="bet-controls">
                    <button class="bet-btn" @click="decreaseBet" :disabled="isSpinning">-</button>
                    <div class="bet-display">{{ currentBet }}</div>
                    <button class="bet-btn" @click="increaseBet" :disabled="isSpinning">+</button>
                </div>

                <div class="button-row">
                    <button @click="startSpin" :disabled="isSpinning || points < currentBet" class="start-btn">
                        {{ isSpinning ? '旋转中...' : '开始旋转' }}
                    </button>
                    <button class="auto-btn" @click="toggleAutoSpin" :disabled="points < currentBet">
                        {{ autoSpin ? '停止自动' : '自动旋转' }}
                    </button>
                </div>
            </div>

            <!-- 全盘奖弹窗 -->
            <div v-if="showFullPrizePopup" class="prize-popup">
                <h2>🎉 全盘奖! 🎉</h2>
                <p>恭喜获得 {{ fullPrizeAmount }} 金额!</p>
            </div>

            <!-- 斜线奖弹窗 -->
            <div v-if="showSpecialPrizePopup" class="special-prize-popup">
                <h2>✨ 斜线奖! ✨</h2>
                <p>恭喜获得 {{ specialPrizeAmount }} 金额!</p>
            </div>

            <!-- 大奖弹窗 -->
            <div v-if="showBigPrizePopup" class="bg-prize-popup">
                <h2>✨ 大奖! ✨</h2>
                <p>恭喜获得 {{ bigPrizeAmount }} 金额!</p>
            </div>

            <div class="rules">
                <h3>游戏规则:</h3>
                <ul>
                    <li><strong>连线奖:</strong> 任意图标在第二行相同，奖励投注金额×3</li>
                    <li><strong>斜线奖:</strong> {{ getSymbolDisplay(specialPrizeSymbol) }}组成45度斜线，奖励投注金额×6</li>
                    <li><strong>大奖1:</strong> 第一行全是{{ getSymbolDisplay(bigPrizeSymbol) }}，奖励投注金额×10</li>
                    <li><strong>大奖2:</strong> 第二行全是{{ getSymbolDisplay(bigPrizeSymbol) }}，奖励投注金额×30</li>
                    <li><strong>大奖3:</strong> 第三行全是{{ getSymbolDisplay(bigPrizeSymbol) }}，奖励投注金额×20</li>
                    <li><strong>全盘奖:</strong> 9个格子图标相同，奖励投注金额×90</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import {playAudio, gameInit, rwIn, rwOut, startSlot} from "../../api/game";

    export default {
        name: "slot",
        data: function () {
            return {
                page_init: false,
                rw_pop: false,
                amount: 1000,
                balance: 0,
                points: 0,
                currentBet: 1000,
                c_bet: 1000,
                winPoints: 0,
                isSpinning: false,
                autoSpin: false,
                autoSpinInterval: null,

                // 图标配置系统 - 可以随意更换这里的图标
                symbols: [
                    {id: 0, display: '🍒'}, // 普通图标
                    {id: 1, display: '🍋'},
                    {id: 2, display: '🍊'},
                    {id: 3, display: '🍇'},
                    {id: 4, display: '🍉'},
                    {id: 5, display: '🥝'},
                    {id: 6, display: '🍌'},
                    {id: 7, display: '🍍'},
                    {id: 8, display: '🍎'},
                    {id: 9, display: '🔔'}  // 特殊大奖图标
                ],

                // 特殊图标配置 - 可以随意修改这些ID来改变中奖图标
                specialPrizeSymbol: 8,  // 斜线奖使用的图标ID
                bigPrizeSymbol: 9,      // 大奖使用的图标ID

                winningMessage: '',
                showLineEffect: false,
                showDiagonalEffect1: false,
                showDiagonalEffect2: false,
                bigPrizeRows: [],
                hasFullPrizeBorder: false,
                showFullPrizePopup: false,
                fullPrizeAmount: 0,
                showSpecialPrizePopup: false,
                specialPrizeAmount: 0,
                showBigPrizePopup: false,
                bigPrizeAmount: 0,
                columns: [
                    {
                        items: [],  // 存储图标ID而不是具体图标
                        position: 0,
                        duration: 0,
                        easing: '0.1, 0.8, 0.2, 1'
                    },
                    {
                        items: [],
                        position: 0,
                        duration: 0,
                        easing: '0.1, 0.8, 0.2, 1'
                    },
                    {
                        items: [],
                        position: 0,
                        duration: 0,
                        easing: '0.1, 0.8, 0.2, 1'
                    }
                ]
            }
        },
        mounted() {
            this.pageInit();
        },
        methods: {
            pageInit() {
                let that = this
                gameInit().then(res => {
                    const data = res.data
                    that.balance = data.balance
                    that.points = data.points
                    that.page_init = true
                    // console.log(data)
                    this.initializeColumns();
                }).catch(res => {
                    that.$dialog.error(res.msg)
                })
            },
            // 充提币按钮
            rwBtn() {
                this.rw_pop = true
            },
            rwClose() {
                this.rw_pop = false
            },
            rwIn() {
                if (this.amount <= 0) {
                    this.$refs.amount.focus()
                    return this.$dialog.error('金额格式错误')
                }

                if (this.balance - this.amount < 0) {
                    this.$refs.amount.focus()
                    return this.$dialog.error('余额不足')
                }
                let that = this
                rwIn({money: that.amount}).then(res => {
                    that.points = parseInt(that.points) + parseInt(that.amount)
                    that.balance = parseInt(that.balance) - parseInt(that.amount)
                    that.rw_pop = false
                    playAudio('sr')
                    that.$dialog.success(res.msg)
                }).catch(res => {
                    that.$dialog.error(res.msg)
                })
            },
            rwOut() {
                if (this.amount <= 0) {
                    this.$refs.amount.focus()
                    return this.$dialog.error('金额格式错误')
                }
                if (this.points < this.amount) {
                    this.$refs.amount.focus()
                    return this.$dialog.error('提币金额要小于等于当前金额')
                }
                let that = this
                rwOut({money: that.amount}).then(res => {
                    playAudio('sw')
                    that.points = parseInt(that.points) - parseInt(that.amount)
                    that.balance = parseInt(that.balance) + parseInt(that.amount)
                    that.rw_pop = false
                    that.$dialog.success(res.msg)
                }).catch(res => {
                    that.$dialog.error(res.msg)
                })
            },
            // 根据ID获取图标显示
            getSymbolDisplay(symbolId) {
                const symbol = this.symbols.find(s => s.id === symbolId);
                return symbol ? symbol.display : '?';
            },

            // 获取随机图标ID
            getRandomSymbolId() {
                return Math.floor(Math.random() * this.symbols.length);
            },

            initializeColumns() {
                this.columns.forEach(column => {
                    column.items = [
                        this.getRandomSymbolId(),
                        this.getRandomSymbolId(),
                        this.getRandomSymbolId()
                    ];
                    column.position = 0;
                    column.duration = 0;
                });
            },
            increaseBet() {
                if (this.currentBet < 100000) {
                    playAudio('bet')
                    this.currentBet += this.c_bet;
                }
            },
            decreaseBet() {
                if (this.currentBet > 1000) {
                    playAudio('bet')
                    this.currentBet -= this.c_bet;
                }
            },
            startSpinold() {
                if (this.isSpinning || this.points < this.currentBet) return;

                this.isSpinning = true;
                this.points -= this.currentBet;
                this.winPoints = 0;
                this.resetEffects();

                const itemHeight = 120;
                const visibleCount = 3;
                const fillerCount = 12;
                const baseDuration = 2000;

                this.columns.forEach((column, index) => {
                    // 1️⃣ 最终结果
                    const result = [
                        this.getRandomSymbolId(),
                        this.getRandomSymbolId(),
                        this.getRandomSymbolId()
                    ];

                    // 2️⃣ 滚动用填充
                    const filler = [];
                    for (let i = 0; i < fillerCount; i++) {
                        filler.push(this.getRandomSymbolId());
                    }

                    // 3️⃣ 追加内容
                    column.items.push(...filler, ...result);

                    // 4️⃣ 目标位移（从当前继续滚）
                    const moveCount = filler.length + visibleCount;
                    const targetPosition = column.position - moveCount * itemHeight;

                    // 5️⃣ 开启动画
                    column.easing = '0.1, 0.8, 0.2, 1';
                    column.duration = baseDuration + index * 500;
                    column.position = targetPosition;
                });

                const maxDuration = baseDuration + (this.columns.length - 1) * 500;

                setTimeout(() => {
                    this.columns.forEach(column => {
                        // 🔴 关键：先关动画
                        column.duration = 0;

                        // 只保留最终 3 个
                        column.items = column.items.slice(-visibleCount);

                        // 归位到“正好显示这 3 个”的位置
                        column.position = 0;

                        // 🔴 强制浏览器吃掉这个状态
                        this.$el.offsetHeight;
                    });

                    this.isSpinning = false;
                    this.checkWins();
                }, maxDuration + 30);
            },
            async startSpin() {

                if (this.isSpinning || this.points < this.currentBet) return;

                this.isSpinning = true;

                // 不在前端扣钱，应该由后端扣
                this.resetEffects();

                let that = this
                startSlot({
                    bet: this.currentBet
                }).then(res => {
                    playAudio('s_wheel')
                    // that.$dialog.success(res.msg)
                    const data = res.data
                    if (!data.grid) {
                        that.$dialog.error('接口错误')
                        this.isSpinning = false;
                        return;
                    }

                    const serverGrid = data.grid;
                    const serverWin = data.win;
                    this.points -= this.currentBet;

                    const itemHeight = 120;
                    const fillerCount = 12;
                    const baseDuration = 2000;

                    this.columns.forEach((column, index) => {

                        // 🔥 取后端列数据
                        const resultColumn = [
                            serverGrid[0][index],
                            serverGrid[1][index],
                            serverGrid[2][index]
                        ];

                        // 前面加随机填充（只是动画）
                        const filler = [];
                        for (let i = 0; i < fillerCount; i++) {
                            filler.push(Math.floor(Math.random() * this.symbols.length));
                        }

                        column.items.push(...filler, ...resultColumn);

                        const moveCount = filler.length + 3;
                        column.duration = baseDuration + index * 500;
                        column.position -= moveCount * itemHeight;
                    });

                    const maxDuration = baseDuration + (this.columns.length - 1) * 500;

                    setTimeout(() => {

                        this.columns.forEach((column, index) => {
                            column.duration = 0;
                            column.items = [
                                serverGrid[0][index],
                                serverGrid[1][index],
                                serverGrid[2][index]
                            ];
                            column.position = 0;
                        });
                        // 🔥 后端给多少就加多少
                        this.winPoints = parseInt(serverWin);
                        // this.points = parseInt(this.points) + parseInt(serverWin);
                        this.isSpinning = false;
                        this.checkWins();
                    }, maxDuration + 50);
                }).catch(res => {
                    that.$dialog.error(res.msg)
                    this.isSpinning = false;
                })
            },
            toggleAutoSpin() {
                this.autoSpin = !this.autoSpin;
                if (this.autoSpin) {
                    const loop = () => {
                        if (!this.autoSpin) return;
                        this.startSpin();
                        setTimeout(loop, 4000);
                    };
                    loop();
                } else {
                    if (this.autoSpinInterval) {
                        clearInterval(this.autoSpinInterval);
                        this.autoSpinInterval = null;
                    }
                }
            },
            checkWins() {
                this.winPoints = 0;
                this.winningMessage = '';
                this.showLineEffect = false;
                this.showDiagonalEffect1 = false;
                this.showDiagonalEffect2 = false;
                this.bigPrizeRows = [];
                this.hasFullPrizeBorder = false;
                this.showFullPrizePopup = false;
                this.showSpecialPrizePopup = false;
                this.showBigPrizePopup = false;

                // 获取当前显示的9个图标ID（从每个列的末尾获取）
                const slotIds = [];
                for (let row = 0; row < 3; row++) {
                    for (let col = 0; col < 3; col++) {
                        const columnItems = this.columns[col].items;
                        slotIds.push(columnItems[columnItems.length - 3 + row]);
                    }
                }

                // 检查全盘奖（最高优先级）- 任意图标相同即可
                const firstSymbolId = slotIds[0];
                if (slotIds.every(id => id === firstSymbolId)) {
                    playAudio('full')
                    this.winPoints = this.currentBet * 90;
                    this.winningMessage = `全盘奖! +${this.winPoints} `;
                    this.hasFullPrizeBorder = true;
                    this.fullPrizeAmount = this.winPoints;
                    this.showFullPrizePopup = true;

                    setTimeout(() => {
                        this.showFullPrizePopup = false;
                    }, 3000);
                } else {
                    // 如果不是全盘奖，检查其他奖项

                    // 检查是否出现大奖
                    const hasBigPrize1 = slotIds[0] === this.bigPrizeSymbol && slotIds[1] === this.bigPrizeSymbol && slotIds[2] === this.bigPrizeSymbol;
                    const hasBigPrize2 = slotIds[3] === this.bigPrizeSymbol && slotIds[4] === this.bigPrizeSymbol && slotIds[5] === this.bigPrizeSymbol;
                    const hasBigPrize3 = slotIds[6] === this.bigPrizeSymbol && slotIds[7] === this.bigPrizeSymbol && slotIds[8] === this.bigPrizeSymbol;
                    const hasBigPrize = hasBigPrize1 || hasBigPrize2 || hasBigPrize3;

                    // 1. 连线奖: 第二行任意图标相同（只有没有大奖时才显示）
                    if (slotIds[3] === slotIds[4] && slotIds[4] === slotIds[5] && !hasBigPrize) {
                        playAudio('win')
                        this.winPoints += this.currentBet * 3;
                        this.winningMessage += `连线奖! +${this.currentBet * 3} `;
                        this.showLineEffect = true;
                    }

                    // 2. 斜线奖: 特殊图标组成45度斜线（只有没有大奖时才显示）
                    // 左斜线: 左上到右下 (1行1列, 2行2列, 3行3列)
                    const leftDiagonal = [slotIds[0], slotIds[4], slotIds[8]];
                    // 右斜线: 左下到右上 (3行1列, 2行2列, 1行3列)
                    const rightDiagonal = [slotIds[6], slotIds[4], slotIds[2]];

                    let hasDiagonalPrize = false;
                    if (leftDiagonal.every(id => id === this.specialPrizeSymbol) && !hasBigPrize) {
                        this.winPoints += this.currentBet * 6;
                        this.winningMessage += `左斜线奖! +${this.currentBet * 6} `;
                        this.showDiagonalEffect1 = true;
                        hasDiagonalPrize = true;
                    }

                    if (rightDiagonal.every(id => id === this.specialPrizeSymbol) && !hasBigPrize) {
                        this.winPoints += this.currentBet * 6;
                        this.winningMessage += `右斜线奖! +${this.currentBet * 6} `;
                        this.showDiagonalEffect2 = true;
                        hasDiagonalPrize = true;
                    }

                    // 显示斜线奖弹窗
                    if (hasDiagonalPrize) {
                        playAudio('win')
                        this.specialPrizeAmount = this.currentBet * 6;
                        this.showSpecialPrizePopup = true;
                        setTimeout(() => {
                            this.showSpecialPrizePopup = false;
                        }, 3000);
                    }

                    // 3. 大奖（优先级高于连线奖和斜线奖）
                    if (hasBigPrize1) {
                        playAudio('win')
                        this.winPoints += this.currentBet * 10;
                        this.bigPrizeAmount = this.winPoints;
                        this.winningMessage += `大奖1! +${this.currentBet * 10} `;
                        this.bigPrizeRows.push(0);
                    }

                    if (hasBigPrize2) {
                        playAudio('win')
                        this.winPoints += this.currentBet * 30;
                        this.bigPrizeAmount = this.winPoints;
                        this.winningMessage += `大奖2! +${this.currentBet * 30} `;
                        this.bigPrizeRows.push(1);
                    }

                    if (hasBigPrize3) {
                        playAudio('win')
                        this.winPoints += this.currentBet * 20;
                        this.bigPrizeAmount = this.winPoints;
                        this.winningMessage += `大奖3! +${this.currentBet * 20} `;
                        this.bigPrizeRows.push(2);
                    }
                    if (hasBigPrize) {
                        this.showBigPrizePopup = true;
                        setTimeout(() => {
                            this.showBigPrizePopup = false;
                        }, 3000);
                    }
                }

                this.points += this.winPoints;

                if (!this.winningMessage) {
                    this.winningMessage = '';
                }
            },
            resetEffects() {
                this.showLineEffect = false;
                this.showDiagonalEffect1 = false;
                this.showDiagonalEffect2 = false;
                this.bigPrizeRows = [];
                this.hasFullPrizeBorder = false;
                this.winningMessage = '';
                this.showFullPrizePopup = false;
                this.showSpecialPrizePopup = false;
            }
        },
        beforeDestroy() {
            if (this.autoSpinInterval) {
                clearInterval(this.autoSpinInterval);
            }
        }
    }
</script>

<style scoped>
    .page-init {
        color: darkgrey;
        text-align: center;
        margin-top: 50px;
    }

    .slot-bg {
        box-sizing: border-box;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', 'Microsoft YaHei', sans-serif;
        -webkit-tap-highlight-color: transparent;

        overflow-x: hidden;
        touch-action: manipulation;

        background: linear-gradient(135deg, #1a2a6c, #b21f1f, #fdbb2d);
        min-height: 100vh;
        padding: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .container {
        max-width: 800px;
        width: 100%;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border-radius: 20px;
        padding: 30px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        color: white;
    }

    h1 {
        text-align: center;
        margin-bottom: 20px;
        text-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
        font-size: .65rem;
    }

    .rw-con {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .rw-img {
        margin-top: 5px;
        width: 21px;
    }

    .rw-popup-con {
        position: absolute;
        z-index: 1000;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .6);
        padding-top: 45%;
        color: #333333;
    }

    .rw-popup {
        background-color: #fff;
        width: 88%;
        margin-left: 6%;
        border-radius: 5px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .rw-popup-close {
        font-size: 28px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .row {
        padding: 5px;
        border-bottom: 1px dashed #ddd;
        width: 98%;
        margin-left: 1%;
    }

    .row i {
        color: darkgrey;
    }

    .row b {
        color: goldenrod;
    }

    .rw-btn-con {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 5px;
        padding: 5px 10px;
    }

    .rw-btn {
        padding: 6px 8px;
    }

    .in {
        background: linear-gradient(45deg, #11998e, #38ef7d);
    }

    .game-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        background: rgba(0, 0, 0, 0.3);
        padding: 15px;
        border-radius: 10px;
    }

    .info-item {
        text-align: center;
    }

    .info-label {
        font-size: .3rem;
        opacity: 0.8;
    }

    .info-value {
        font-size: .5rem;
        font-weight: bold;
    }

    .winning-info {
        text-align: center;
        font-size: .6rem;
        margin: 10px 0;
        min-height: 30px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(0, 0, 0, 0.7);
        padding: 10px 20px;
        border-radius: 10px;
        z-index: 20;
        pointer-events: none;
    }

    .game-area {
        position: relative;
        margin-bottom: 20px;
    }

    .slot-machine {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
        position: relative;
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
    }

    .slot-column {
        position: relative;
        height: 360px;
        overflow: hidden;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        border: 2px solid rgba(255, 255, 255, 0.2);
    }

    .slot-wheel {
        position: absolute;
        width: 100%;
        transition: transform 0.1s ease-out;
    }

    .slot-item {
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .85rem;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    .slot-item:last-child {
        border-bottom: none;
    }

    .controls {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        flex-wrap: wrap;
        gap: 10px;
    }

    .bet-controls {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 1;
        justify-content: center;
    }

    .button-row {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 1;
        justify-content: center;
    }

    button {
        padding: 12px 20px;
        border: none;
        border-radius: 50px;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.3s;
        background: linear-gradient(45deg, #FF512F, #F09819);
        color: white;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        min-width: 120px;
    }

    button:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    }

    button:active {
        transform: translateY(1px);
    }

    button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }

    .auto-btn {
        background: linear-gradient(45deg, #11998e, #38ef7d);
    }

    .stop-btn {
        background: linear-gradient(45deg, #ff416c, #ff4b2b);
    }

    .bet-btn {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .5rem;
        padding: 0;
        min-width: auto;
    }

    .bet-display {
        min-width: 60px;
        text-align: center;
        font-size: .5rem;
        font-weight: bold;
        background: rgba(0, 0, 0, 0.3);
        padding: 10px;
        border-radius: 10px;
    }

    /* 连线特效 */
    .line-effect {
        position: absolute;
        z-index: 10;
        animation: line-pulse 0.5s infinite alternate;
        pointer-events: none;
    }

    .horizontal-line {
        height: 5px;
        width: 100%;
        left: 0;
        top: 50%;
        margin-top: -2.5px;
        background: linear-gradient(90deg,
        rgba(255, 0, 0, 0) 0%,
        rgba(255, 0, 0, 0.8) 20%,
        rgba(255, 0, 0, 1) 50%,
        rgba(255, 0, 0, 0.8) 80%,
        rgba(255, 0, 0, 0) 100%);
        box-shadow: 0 0 20px red, 0 0 30px red;
    }

    /* 斜线特效 */
    .diagonal-line-1, .diagonal-line-2 {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 130%;
        height: 4px;
        background: linear-gradient(90deg,
        transparent 0%,
        rgba(255, 255, 0, 0.9) 45%,
        rgba(255, 255, 0, 1) 50%,
        rgba(255, 255, 0, 0.9) 55%,
        transparent 100%);
        box-shadow: 0 0 20px yellow, 0 0 40px orange;
        transform-origin: center;
        pointer-events: none;
    }

    /* 左上 → 右下 */
    .diagonal-line-1 {
        transform: translate(-50%, -50%) rotate(40deg) translateX(-2%);
        animation: slash1 0.8s linear infinite;
    }

    /* 左下 → 右上 */
    .diagonal-line-2 {
        transform: translate(-50%, -50%) rotate(-40deg) translateX(-2%);
        animation: slash2 0.8s linear infinite;
    }

    /* 切割动画 */
    @keyframes slash1 {
        from {
            transform: translate(-50%, -50%) rotate(40deg) translateX(-2%);
            opacity: 0;
        }
        10% {
            opacity: 1;
        }
        to {
            transform: translate(-50%, -50%) rotate(40deg) translateX(2%);
            opacity: 0;
        }
    }

    @keyframes slash2 {
        from {
            transform: translate(-50%, -50%) rotate(-40deg) translateX(-2%);
            opacity: 0;
        }
        10% {
            opacity: 1;
        }
        to {
            transform: translate(-50%, -50%) rotate(-40deg) translateX(2%);
            opacity: 0;
        }
    }

    @keyframes line-pulse {
        0% {
            opacity: 0.7;
            transform: scaleX(0.95);
        }
        100% {
            opacity: 1;
            transform: scaleX(1.05);
        }
    }

    /* 大奖行闪烁 */
    .row-border {
        position: absolute;
        left: 0;
        width: 100%;
        height: 120px;
        border: 4px solid gold;
        animation: rowFlash 0.4s infinite alternate;
        z-index: 20;
        pointer-events: none;
    }

    .row-0 {
        top: 0;
    }

    .row-1 {
        top: 120px;
    }

    .row-2 {
        top: 240px;
    }

    @keyframes rowFlash {
        from {
            box-shadow: 0 0 15px gold;
        }
        to {
            box-shadow: 0 0 45px orange;
        }
    }

    /* 全盘奖边框特效 */
    .full-prize-border {
        animation: rainbow 1s infinite;
    }

    @keyframes rainbow {
        0% {
            box-shadow: 0 0 40px red;
        }
        25% {
            box-shadow: 0 0 40px orange;
        }
        50% {
            box-shadow: 0 0 40px yellow;
        }
        75% {
            box-shadow: 0 0 40px green;
        }
        100% {
            box-shadow: 0 0 40px cyan;
        }
    }

    /* 奖金弹窗 */
    .prize-popup {
        width: 92%;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: linear-gradient(45deg, #ff0080, #ff8c00);
        padding: 15px;
        border-radius: 15px;
        text-align: center;
        z-index: 100;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
        animation: popup-appear 0.5s;
    }

    .prize-popup h2 {
        font-size: .45rem;
        margin-bottom: 10px;
    }

    .prize-popup p {
        font-size: .35rem;
    }

    @keyframes popup-appear {
        0% {
            transform: translate(-50%, -50%) scale(0.5);
            opacity: 0;
        }
        100% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        }
    }

    .rules {
        background: rgba(0, 0, 0, 0.3);
        padding: 15px;
        border-radius: 10px;
        margin-top: 20px;
        font-size: .25rem;
    }

    .rules h3 {
        margin-bottom: 5px;
    }

    .rules ul {
        padding-left: 8px;
    }

    .rules li {
        margin-bottom: 5px;
    }

    .slot-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 5;
    }

    .mask-top, .mask-bottom {
        position: absolute;
        left: 0;
        width: 100%;
        height: 20px;
        background: linear-gradient(to bottom,
        rgba(26, 42, 108, 0.9) 0%,
        rgba(26, 42, 108, 0) 100%);
    }

    .mask-top {
        top: 0;
    }

    .mask-bottom {
        bottom: 0;
        background: linear-gradient(to top,
        rgba(26, 42, 108, 0.9) 0%,
        rgba(26, 42, 108, 0) 100%);
    }

    .center-line {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 5px;
        background: rgba(255, 215, 0, .3);
        box-shadow: 0 0 15px gold;
        z-index: 6;
    }

    .special-prize-popup {
        width: 92%;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: linear-gradient(45deg, #ffd700, #ff8c00);
        padding: 15px;
        border-radius: 15px;
        text-align: center;
        z-index: 100;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
        animation: popup-appear 0.5s;
    }

    .bg-prize-popup {
        width: 92%;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: linear-gradient(45deg, goldenrod, orangered);
        padding: 15px;
        border-radius: 15px;
        text-align: center;
        z-index: 100;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
        animation: popup-appear 0.5s;
    }

    .special-prize-popup h2 {
        font-size: .45rem;
        margin-bottom: 10px;
    }

    .special-prize-popup p {
        font-size: .35rem;
    }

    @keyframes pulse {
        from {
            opacity: .5;
        }
        to {
            opacity: 1;
        }
    }
</style>